import { Worlds } from '../mode/Mode';
import introCB1 from '../../media/intro/cuenca-baja/1.jpg';
import introCB2 from '../../media/intro/cuenca-baja/2.jpg';
import introCB3 from '../../media/intro/cuenca-baja/3.jpg';
import introCB4 from '../../media/intro/cuenca-baja/4.jpg';
import introCB5 from '../../media/intro/cuenca-baja/5.jpg';
import introCM1 from '../../media/intro/cuenca-media/1.jpg';
import introCM2 from '../../media/intro/cuenca-media/2.jpg';
import introCM3 from '../../media/intro/cuenca-media/3.jpg';
import introCM4 from '../../media/intro/cuenca-media/4.jpg';
import introCM5 from '../../media/intro/cuenca-media/5.jpg';
import introCM6 from '../../media/intro/cuenca-media/6.jpg';
import introCM7 from '../../media/intro/cuenca-media/7.jpg';
import introCA1 from '../../media/intro/cuenca-alta/1.jpg';
import introCA2 from '../../media/intro/cuenca-alta/2.jpg';
import introCA3 from '../../media/intro/cuenca-alta/3.jpg';
import introCA4 from '../../media/intro/cuenca-alta/4.jpg';
import introCA5 from '../../media/intro/cuenca-alta/5.jpg';
import introCA6 from '../../media/intro/cuenca-alta/6.jpg';
import introCA7 from '../../media/intro/cuenca-alta/7.jpg';
import introCA8 from '../../media/intro/cuenca-alta/8.jpg';
import introCA9 from '../../media/intro/cuenca-alta/9.jpg';
import introGL1 from '../../media/intro/glaciar/1.jpg';
import introGL2 from '../../media/intro/glaciar/2.jpg';
import introGL3 from '../../media/intro/glaciar/3.jpg';
import introGL4 from '../../media/intro/glaciar/4.jpg';
import introGL5 from '../../media/intro/glaciar/5.jpg';
import introGL6 from '../../media/intro/glaciar/6.jpg';

export interface Intro {
    images: Array<string>;
    copyright?: Array<string | null>;
    audioDuration: number;
}

type Intros = {
    [key in Worlds]: Intro;
};

const intros: Intros = {
    'cuenca-baja': {
        images: [introCB1, introCB2, introCB3, introCB4, introCB5],
        audioDuration: 20000,
    },
    'cuenca-media': {
        images: [introCM1, introCM2, introCM3, introCM4, introCM5, introCM6, introCM7],
        audioDuration: 20000,
    },
    'cuenca-alta': {
        images: [introCA1, introCA2, introCA3, introCA4, introCA5, introCA6, introCA7, introCA8, introCA9],
        audioDuration: 42000,
    },
    glaciar: {
        images: [introGL1, introGL2, introGL3, introGL4, introGL5, introGL6],
        copyright: [
            'Ideam',
            'Francisco Rojas',
            'Jorge Luis Ceballos',
            'Jorge Luis Ceballos',
            'Jorge Luis Ceballos',
            'Megan Janetsky ',
        ],
        audioDuration: 43000,
    },
};

export default intros;
